import { getBicNlList } from "../../../service/BicService"
import { BIC_NL } from "./constants"

// Liste locale utilisée comme fallback si le fetch backend échoue ou n'a pas encore répondu.
let bicNlMap = BIC_NL

// Garde de mémorisation : garantit un seul fetch, même en cas de remount.
let loadPromise = null

/**
 * Transforme le tableau renvoyé par le backend
 * (ex. [{ code: "ABNA", bic: "ABNANL2A" }, ...]) en map { ABNA: "ABNANL2A", ... }.
 */
function toBicMap(list) {
  if (!Array.isArray(list)) return null
  return list.reduce((map, item) => {
    const code = item?.code ?? item?.bankCode
    const bic = item?.bic ?? item?.bicCode
    if (code && bic) {
      map[code] = bic
    }
    return map
  }, {})
}

/**
 * Récupère la liste des BIC NL depuis le backend une seule fois.
 * En cas d'échec, on conserve la liste locale comme fallback.
 * @param tunnelData - data of journey
 */
export function loadBicNlOnce(tunnelData) {
  if (loadPromise) return loadPromise
  loadPromise = getBicNlList(tunnelData)
    .then((list) => {
      const map = toBicMap(list)
      if (map && Object.keys(map).length > 0) {
        bicNlMap = map
      }
      return bicNlMap
    })
    .catch(() => bicNlMap)
  return loadPromise
}

/** Accès synchrone à la map BIC NL (backend si chargé, sinon fallback local). */
export function getBicNl() {
  return bicNlMap
}
